import { render, staticRenderFns } from "./DiscreteColorLegend.vue?vue&type=template&id=6459a431"
import script from "./DiscreteColorLegend.vue?vue&type=script&lang=js"
export * from "./DiscreteColorLegend.vue?vue&type=script&lang=js"
import style0 from "./DiscreteColorLegend.vue?vue&type=style&index=0&id=6459a431&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports